import { BUILDING_MATERIAL_TYPE_PRESENTER, IOfferBuilding } from '../../types/offers';

export const getMaterialType = (building?: IOfferBuilding): string | undefined => {
  if (building && building.materialType) {
    return BUILDING_MATERIAL_TYPE_PRESENTER[building.materialType];
  }

  return undefined;
};
